import { isString, isNumber, isInteger } from "./Validation.js";
const DOMAIN_REGEXP = /^[a-z0-9][-a-z0-9]{0,62}(\.[a-z0-9][-a-z0-9]{0,62})*\.[a-z]{2,26}$/i;
const DOMAIN_MIN_LENGTH = 1;
const DOMAIN_MAX_LENGTH = 255;
const EMAIL_REGEXP = /^[-+_a-z0-9][-+_.a-z0-9]{0,62}@[a-z0-9][-a-z0-9]{0,62}(\.[a-z0-9][-a-z0-9]{0,62})*\.[a-z]{2,26}$/i;
const EMAIL_MAX_LENGTH = 255;
const EMAIL_MIN_LENGTH = 6;
function isIPv4Address(input) {
  return isString(input) && /^\d{1,3}(\.\d{1,3}){3}$/.test(input) && input.split(".").map((v) => parseInt(v)).every((x) => x >= 0 && x <= 255);
}
function isIPv4IntAddress(input) {
  return isNumber(input) && isInteger(input) && input >= -2147483648 && input <= 2147483647;
}
function isIPv4UIntAddress(input) {
  return isNumber(input) && isInteger(input) && input >= 0 && input <= 4294967295;
}
function toIPv4IntAddress(input) {
  if (!isIPv4Address(input)) {
    throw new TypeError("Invalid IPv4 string address");
  }
  return input.split(".").map((v) => parseInt(v)).reduce((acc, v) => acc << 8 | v, 0);
}
function toIPv4UIntAddress(input) {
  return toIPv4IntAddress(input) >>> 0;
}
function fromIPv4UIntAddress(input) {
  if (!isIPv4UIntAddress(input)) {
    throw new TypeError("Invalid IPv4 unsigned integer address");
  }
  return [
    input >>> 24,
    input >>> 16 & 255,
    input >>> 8 & 255,
    input & 255
  ].join(".");
}
function fromIPv4IntAddress(input) {
  if (!isIPv4IntAddress(input)) {
    throw new TypeError("Invalid IPv4 unsigned integer address");
  }
  return [
    input >>> 24,
    input >>> 16 & 255,
    input >>> 8 & 255,
    input & 255
  ].join(".");
}
function isDomain(domain) {
  return domain.length >= DOMAIN_MIN_LENGTH && domain.length < DOMAIN_MAX_LENGTH && DOMAIN_REGEXP.test(domain);
}
function isEMailAddress(email) {
  return email.length >= EMAIL_MIN_LENGTH && email.length < EMAIL_MAX_LENGTH && !email.includes("..") && !email.includes(".@") && EMAIL_REGEXP.test(email);
}
export {
  fromIPv4IntAddress,
  fromIPv4UIntAddress,
  isDomain,
  isEMailAddress,
  isIPv4Address,
  isIPv4IntAddress,
  isIPv4UIntAddress,
  toIPv4IntAddress,
  toIPv4UIntAddress
};
//# sourceMappingURL=Network.js.map
